module.exports = __webpack_public_path__ + "e8f45969533b9e78b0c7d7fcbb3664d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camscreen1.jpg
// module id = 165
// module chunks = 0